import React, { useContext, useState } from 'react';
import { CloseCircleOutlined, MenuOutlined } from '@ant-design/icons';
import { Layout, Drawer, Button } from 'antd';
import { UserContext } from '../../../Context';
import LogoLg from '../../../Assets/header-logo4.png';
import LogoSm from '../../../Assets/header-logo6.png';
import MenuRender from '../../Common/MenuRender';

const { Sider } = Layout;

const Sidemenu = ({ notificationCount }) => {
	const { collapsed } = useContext(UserContext);
	const [open, setOpen] = useState(false);

	return (
		<>
			{/* Button for Mobile Menu */}
			<Button
				className="md:hidden absolute top-2 left-3.5 border border-solid border-white text-white"
				type="text"
				icon={<MenuOutlined />}
				onClick={() => setOpen(true)}
			>
				Menu
			</Button>
			<Drawer
				title={<img src={LogoLg} width={'80%'} alt='logo' />}
				placement="left"
				width={320}
				onClose={() => setOpen(false)}
				open={open}
				closeIcon={false}
				extra={
					<Button 
						type='text' 
						icon={<CloseCircleOutlined className="text-red-300 !text-2xl" onClick={() => setOpen(false)} />} 
					/>
				}
				className="md:hidden mobile-menu"
			>
				<MenuRender
					count={notificationCount}
					onClose={() => setOpen(false)}
				/>
			</Drawer>
			<Sider trigger={null} collapsible collapsed={collapsed} width={230} className="hidden md:block">
				<div className={` ${collapsed ? '' : 'fixed w-[230px]'}`}>
					<div className='logo-area flex items-center justify-center'>
						<img src={collapsed ? LogoSm : LogoLg} width={collapsed ? '60%' : '80%'} alt='logo' />
					</div>
					<div className='overflow-y-auto h-[calc(100vh-50px)]'>
						<MenuRender
							count={notificationCount}
						/>
					</div>
				</div>
			</Sider>
		</>
	);
};

export default Sidemenu;
